import React from "react"
import useHomeStore from "../../../../../store/homeStore"
import AdvertisingBanner from "../../Advertising/AdvertisingBanner"
import MaintenanceBanner from "../../Maintenance/MaintenanceBanner"
import styles from "../../../../../pages/Home/Home.module.scss"

export const BannersContainer: React.FC = () => {
    const { notifications } = useHomeStore()

    return (
      <div className={styles.bannerContainer}>
        {notifications.length > 0 && <MaintenanceBanner />}
        <AdvertisingBanner />
      </div>
    )
  }